import React from 'react';
import { Section, TwoColumns } from 'src/components/Section';
import { SectionSubtitle, Paragraph } from 'src/components/Typography';
import { AnchorButton } from 'src/components/Button';
import sizes from 'src/style/sizes';
import { mediaQueries } from 'src/style/breakpoints';

const CTAFooter = () => {
  return (
    <Section theme="primary">
      <TwoColumns
        sizeLeft={sizes.columnWidth.large}
        left={
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: 'center',
              [mediaQueries.tabletLandscapeUp]: {
                justifyContent: 'flex-start',
                textAlign: 'left',
              },
            }}
          >
            <SectionSubtitle>D'autres questions ?</SectionSubtitle>
            <Paragraph>
              Deux fois par mois, venez rencontrer Xavier lors d'une réunion d’information. Le
              programme de formation vous sera présenté et il répondra à toutes vos questions.
            </Paragraph>
          </div>
        }
        sizeRight={sizes.columnWidth.medium}
        right={
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
              paddingTop: 0,
              [mediaQueries.tabletLandscapeUp]: {
                justifyContent: 'flex-end',
                paddingTop: 40,
                paddingLeft: 160,
              },
            }}
          >
            {/* <Button>
              <a
                css={{ textDecoration: 'none', color: colors.purple }}
                // target="_blank"
                rel="noopener noreferrer"
                href="https://www.meetup.com/fr-FR/LeReacteurIO"
              >
                S'inscrire
              </a>
            </Button> */}
            <AnchorButton to="/evenements/inscription">S'inscrire</AnchorButton>
          </div>
        }
      />
    </Section>
  );
};
export default CTAFooter;
